/* Lun theme — AJAX cart, drawer and product page helpers */
(function () {
  'use strict';
  var R = window.LunRoutes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js', cartPage: '/cart' };

  function formatMoney(cents) {
    var fmt = window.LunMoneyFormat || '${{amount}}';
    var value = (cents / 100);
    var withDelims = function (num, prec, thou, dec) {
      var parts = num.toFixed(prec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('[data-cart-link]').forEach(function (el) {
      el.setAttribute('aria-label', 'Bag, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  var drawer = null, lastFocus = null;

  function renderDrawer(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('[data-drawer-body]');
    var sub = drawer.querySelector('[data-drawer-subtotal]');
    var foot = drawer.querySelector('[data-drawer-foot]');
    if (!cart.items.length) {
      body.innerHTML = '<p class="drawer__empty">Your bag is empty.</p>';
      foot.hidden = true;
    } else {
      body.innerHTML = cart.items.map(function (item, i) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="drawer__item-variant">' + esc(item.variant_title) + '</span>' : '';
        return '<div class="drawer__item">' +
          (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '<span></span>') +
          '<div><a class="drawer__item-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
          '<div class="qty" role="group" aria-label="Quantity for ' + esc(item.product_title) + '">' +
          '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
          '</div></div>' +
          '<span>' + formatMoney(item.final_line_price) + '</span>' +
          '</div>';
      }).join('');
      foot.hidden = false;
    }
    sub.textContent = formatMoney(cart.total_price);
    updateCount(cart.item_count);
  }

  function getCart() {
    return fetch(R.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function openDrawer() {
    if (!drawer) { window.location.href = R.cartPage; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('.drawer__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function changeLine(line, qty) {
    return fetch(R.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(renderDrawer);
  }

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var msg = form.querySelector('[data-form-msg]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    if (msg) msg.textContent = '';
    return fetch(R.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to bag.');
        return data;
      });
    }).then(function () {
      return getCart();
    }).then(function (cart) {
      renderDrawer(cart);
      openDrawer();
    }).catch(function (err) {
      if (msg) msg.textContent = err.message; else alert(err.message);
    }).finally(function () {
      if (btn) { btn.disabled = false; btn.textContent = label; }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    drawer = document.querySelector('[data-cart-drawer]');

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.matches && form.matches('form[data-ajax-cart]')) {
        e.preventDefault();
        addToCart(form);
      }
    });

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-link]');
      if (opener && drawer && !document.body.classList.contains('template-cart')) {
        e.preventDefault();
        getCart().then(function (cart) { renderDrawer(cart); openDrawer(); });
        return;
      }
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
      var qtyBtn = e.target.closest('[data-line]');
      if (qtyBtn && drawer && drawer.contains(qtyBtn)) {
        changeLine(parseInt(qtyBtn.dataset.line, 10), parseInt(qtyBtn.dataset.qty, 10));
      }
      var step = e.target.closest('[data-qty-step]');
      if (step) {
        var input = step.parentElement.querySelector('input');
        var v = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10);
        input.value = Math.max(parseInt(input.min || '0', 10), v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });

    /* Product page: variant selection (pill radios) + swatch gallery */
    document.querySelectorAll('[data-product-section]').forEach(function (sec) {
      var form = sec.querySelector('[data-product-form]');
      var json = sec.querySelector('[data-variants-json]');
      if (!form || !json) return;
      var variants = JSON.parse(json.textContent);
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = sec.querySelector('[data-product-price]');
      var btn = form.querySelector('[type="submit"]');
      var mainImg = sec.querySelector('[data-swatch-main]');
      var thumbs = sec.querySelectorAll('[data-media-src]');

      function showMedia(mediaId) {
        thumbs.forEach(function (t) {
          var on = String(t.dataset.mediaId) === String(mediaId);
          t.setAttribute('aria-current', on ? 'true' : 'false');
          if (on && mainImg) { mainImg.src = t.dataset.mediaSrc; mainImg.alt = t.dataset.mediaAlt || ''; }
        });
      }

      function chosen() {
        var vals = [];
        form.querySelectorAll('[data-option-index]:checked').forEach(function (r) {
          vals[parseInt(r.dataset.optionIndex, 10)] = r.value;
        });
        return vals;
      }

      function update() {
        var vals = chosen();
        vals.forEach(function (v, i) {
          var lab = sec.querySelector('[data-option-label="' + i + '"]');
          if (lab) lab.textContent = v;
        });
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return vals[i] === undefined || o === vals[i]; });
        });
        if (!match) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
        idInput.value = match.id;
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to cart' : 'Sold out';
        if (priceEl) priceEl.innerHTML = formatMoney(match.price) + (match.compare_at_price > match.price ? ' <s>' + formatMoney(match.compare_at_price) + '</s>' : '');
        if (match.featured_media) showMedia(match.featured_media.id);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }

      form.querySelectorAll('[data-option-index]').forEach(function (r) { r.addEventListener('change', update); });

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var vid = t.dataset.variantId;
          var v = vid && variants.find(function (x) { return String(x.id) === vid; });
          if (v) {
            v.options.forEach(function (o, i) {
              form.querySelectorAll('[data-option-index="' + i + '"]').forEach(function (r) { r.checked = r.value === o; });
            });
            update();
          } else {
            showMedia(t.dataset.mediaId);
          }
        });
      });
    });

    /* Shop page: filter tabs (by product type) */
    document.querySelectorAll('[data-shop-filter]').forEach(function (shop) {
      var empty = shop.querySelector('[data-shop-empty]');
      shop.querySelectorAll('[data-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = btn.dataset.filter;
          shop.querySelectorAll('[data-filter]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          var shown = 0;
          shop.querySelectorAll('.product-card').forEach(function (card) {
            var match = !f || card.dataset.productType === f;
            card.classList.toggle('is-hidden', !match);
            if (match) shown++;
          });
          if (empty) {
            empty.hidden = shown > 0;
            empty.textContent = btn.dataset.empty || 'Nothing here yet.';
          }
        });
      });
    });

  });
})();
